module.exports = __webpack_public_path__ + "media/ready.42ffb469.mp3";